/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoadingDots } from "components/loadingDots";
import { Button } from "components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/tooltip";
import { useEffect, useState } from "react";
import { IDivergence } from "src/@types/divergence";
import { MdEmail } from "react-icons/md";

interface WaitReturnFooterProps {
  methods: any;
  availableItems: IDivergence[];
  baseDisabledReason: string | null;
  isProcessing: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

/**
 * Footer isolado: state interno (allCommentsFilled) só re-renderiza este
 * componente, sem afetar a DataTable e seus inputs.
 */
export default function WaitReturnFooter({
  methods,
  availableItems,
  baseDisabledReason,
  isProcessing,
  onClose,
  onSubmit,
}: WaitReturnFooterProps) {
  const { watch } = methods;
  const [allCommentsFilled, setAllCommentsFilled] = useState(false);

  useEffect(() => {
    const checkComments = (formData: any) => {
      if (!availableItems.length) return true;
      return availableItems.every((item: IDivergence) => {
        const fieldValue = formData[`divergence_${item.id}`]?.analyst;
        return typeof fieldValue === "string" && fieldValue.trim().length >= 3;
      });
    };

    setAllCommentsFilled(checkComments(methods.getValues()));

    const subscription = watch((formData: any, { name }: { name?: string }) => {
      if (!name || !name.includes(".analyst")) return;
      setAllCommentsFilled(checkComments(formData));
    });

    return () => subscription.unsubscribe();
  }, [watch, availableItems, methods]);

  const disabledReason = baseDisabledReason
    ?? (!allCommentsFilled ? "Preencha os comentários de todas as divergências antes de solicitar" : null);
  const isButtonDisabled = disabledReason !== null;

  return (
    <div className="flex items-center justify-between gap-3 mt-4 p-3 bg-[#F9FBFC] rounded-lg border">
      <Button variant="outline" type="button" onClick={onClose}>
        Voltar
      </Button>

      <TooltipProvider delayDuration={100}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="inline-block">
              <Button
                type="submit"
                className="save"
                disabled={isButtonDisabled}
                onClick={onSubmit}
              >
                <MdEmail className="mr-2 h-5 w-5" />
                <LoadingDots isLoading={isProcessing} text={"Solicitar Envio"} />
              </Button>
            </span>
          </TooltipTrigger>
          {disabledReason && (
            <TooltipContent
              side="top"
              className="bg-[#2B0C1A] text-white border-none z-[9999]"
              sideOffset={5}
            >
              <p className="text-sm">{disabledReason}</p>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
